import { ReactNode, Fragment } from 'react';

export interface PageHeaderProps {
  crumbs: string[];
  title: string;
  caption?: ReactNode;
  actions?: ReactNode;
}

export function PageHeader({ crumbs, title, caption, actions }: PageHeaderProps) {
  return (
    <>
      <div className="ds-breadcrumb">
        {crumbs.map((c, i) => (
          <Fragment key={i}>
            {i > 0 && <span className="ds-breadcrumb-sep">/</span>}
            <span>{c}</span>
          </Fragment>
        ))}
      </div>
      <div className="ds-page-h">
        <div>
          <h1>{title}</h1>
          {caption ? <div className="ds-page-h-sub">{caption}</div> : null}
        </div>
        {actions ? <div className="ds-page-h-actions">{actions}</div> : null}
      </div>
    </>
  );
}

export default PageHeader;
